import { paths } from "helpers/paths";
import React, { Component } from "react";
import { delOrgAvatar, updateOrgAvatar } from "sources/profile/organization";
import { delUserAvatar, updateUserAvatar } from "sources/profile/user";
import { AvatarWrapper } from "./avatar";
import { HeadBody } from "./headBody";

export default class ProfileHead extends Component {
    close = () => {
        this.props.history.push(paths.root);
    };

    addAvatar = () => {
        const { isAdmin, getOrg, getUser, modal } = this.props;
        return modal({
            name: "fileUpload",
            title: "Загрузка аватара",
            propName: "avatar",
            uploadFile: (params) => {
                return isAdmin ? updateOrgAvatar(params) : updateUserAvatar(params);
            },
            action: () => {
                isAdmin ? getOrg() : getUser();
            },
        });
    };

    delAvatar = () => {
        const { isAdmin, getOrg, getUser, modal } = this.props;
        const action = () => (isAdmin ? delOrgAvatar() : delUserAvatar()).then(() => (isAdmin ? getOrg() : getUser()));
        return modal({
            name: "confirm",
            title: "Удаление аватара",
            text: "Вы уверены, что хотите удалить аватар?",
            action,
        });
    };

    renderAvatar = () => {
        const { isAdmin, profile, organization } = this.props;
        const url = isAdmin ? organization.imageUrl : profile.imageUrl;
        return <AvatarWrapper add={this.addAvatar} del={this.delAvatar} imageUrl={url} />;
    };

    renderHeadBody = () => {
        const { isAdmin, profile, organization } = this.props;
        let props = { name: profile.fullName, email: profile.email, phoneNumber: profile.phoneNumber };
        if (isAdmin) {
            props = {
                name: organization.name,
                email: organization.email,
                phoneNumber: organization.phoneNumber,
                inn: organization.inn,
            };
        }
        return <HeadBody {...props} />;
    };

    render() {
        const { location } = this.props;
        return (
            <div
                className={`profile__head profile-head ${location.pathname.startsWith(paths.profileBilling) ? "container-fluid" : "container-xl"}`}
            >
                <div className="profile-head__back-link close" onClick={this.close} />
                {this.renderAvatar()}
                {this.renderHeadBody()}
            </div>
        );
    }
}
